import RootContainer from './RootContainer';

export default RootContainer;
